import React, { useEffect, useRef, useState } from "react";
import { getRugTypeID } from "../../utilities/functions";
import RugAPI from "../../api/rug";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import AfshanRug from "./rugTemplates/afshanRug";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import ModernRug from "./rugTemplates/modernRug";
import StoreCard from "./storeCard";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Header from "../header";
import RugTabs from "./rugTabs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ImageRugs from "./rugTemplates/imageRugs";
import Draggable from "react-draggable";

const NewRugPreview = (props) => {
  const [rugs, setRugs] = useState([]);
  const [selectedRug, setSelectedRug] = useState({});
  const [selectedRugIndex, setSelectedRugIndex] = useState(0);
  const [similarRugs, setSimilarRugs] = useState([]);
  const [activeSimilarRugs, setActiveSimilarRugs] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [sellersOrder, setSellersOrder] = useState("on_sale");
  const [sellersRugId, setSellersRugId] = useState(0);
  const [sellersLoading, setSellersLoading] = useState(true);
  const [show3D, setShow3D] = useState(false);
  const [isOpenSortList, setIsOpenSortList] = useState(false);
  const [activeTabs, setActiveTabs] = useState("");
  const [selectedBackground, setSelectedBackground] = useState(0);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const draggRef = useRef(null);
  const { texts } = props;
  const { themeDirection } = props.globalState;
  const imageRef = useRef();

  useEffect(() => {
    const page = props?.context?.location.state.page;
    if (
      props.context &&
      props.context.location.state &&
      props.context.location.state.rugs.length > 0
    ) {
      setRugs(props.context.location.state.rugs);
      if (page == "your_rug") {
        setSelectedRug(props.context.location.state.rugs[0]);
      }
    } else {
      props.context.history.push("/gegenerator");
    }

    setActiveTabs(page);
  }, []);

  useEffect(() => {
    if (rugs.length > 0) {
      loadSimilarRugs();
    }
  }, [rugs]);

  useEffect(() => {
    if (activeTabs !== "your_rug" && activeSimilarRugs?.length > 0) {
      rugClickHandler(activeSimilarRugs[0], 0, "similar");
    }
  }, [activeTabs, activeSimilarRugs]);

  const backgroundImages = [
    "./static/img/bitmap.webp",
    "./static/img/pic1.jpg",
    "./static/img/pic2.jpg",
    "./static/img/pic3.jpg",
  ];
  const loadSimilarRugs = () => {
    let similarRugs = [];
    rugs.map((rug, i) => {
      const rugAPIObj = new RugAPI();
      const toranj = rug.toranj ? rug.toranj.id : 0;
      const corner = rug.corner ? rug.corner.id : 0;
      const border = rug.border ? rug.border.id : 0;
      const tile = rug.tile ? rug.tile.id : 0;
      const background = rug.background ? rug.background.id : 0;
      const pattern = rug.pattern ? rug.pattern.id : 0;
      const rugTypeID = getRugTypeID(rug.type);
      rugAPIObj
        .findRug(rugTypeID, toranj, corner, tile, background, border, pattern)
        .then((response) => {
          if (response.success) {
            similarRugs[i] = response.data;
          } else {
            similarRugs[i] = [];
          }
          setSimilarRugs([...similarRugs]);
          handleSelectedSimilarRugs(selectedRugIndex);
        });
      return "";
    });
  };

  const scrollRef = useRef();
  const similarScrollRef = useRef();

  useEffect(() => {
    handleSelectedSimilarRugs(selectedRugIndex);
  }, [similarRugs, selectedRugIndex]);

  const handleSelectedSimilarRugs = (selectedRugIndex) => {
    setActiveSimilarRugs(similarRugs[selectedRugIndex]);
  };

  const handleManualScroll = (id, direction) => {
    const slider = document.getElementById(id);
    const scroll = direction === "right" ? -120 : 120;

    slider.scrollLeft += scroll;
  };

  const handleSelectedRugs = (rug, i, type) => {
    // let key = rug.type + i;
    let key = rug.id;
    // Rug type is different when its coming from the API
    let rugType = rug.id ? rug.rug_type : rug.type;
    switch (rugType) {
      case "lachak-toranj":
        return (
          <div
            className={`${i != 0 && !isMobile ? "mr-3" : "m-0"} check`}
            key={key}
            onClick={() => rugClickHandler(rug, i, type)}
          >
            <LachakToranjRug
              background={rug.background}
              border={rug.border}
              corner={rug.corner}
              toranj={rug.toranj}
              show={true}
            />
          </div>
        );
      case "kheshti":
        return (
          <div
            className="check"
            key={key}
            onClick={() => rugClickHandler(rug, i, type)}
          >
            {/* <span> 23%</span> */}
            <KheshtiRug
              background={rug.background}
              border={rug.border}
              corner={rug.corner}
              toranj={rug.toranj}
              tile={rug.tile}
              show={true}
            />
          </div>
        );

      default:
        return (
          <div
            className="check active"
            key={key}
            onClick={() => rugClickHandler(rug, i, type)}
          >
            <AfshanRug
              background={rug.background}
              border={rug.border}
              corner={rug.corner}
              toranj={rug.toranj}
              show={true}
            />
          </div>
        );
    }
  };

  const showSelectedRug = (selectedRug) => {
    let rugtype = selectedRug.id ? selectedRug.rug_type : selectedRug.type;
    switch (rugtype) {
      case "kheshti":
        return (
          <KheshtiRug
            background={selectedRug.background}
            tile={selectedRug.tile}
            show={true}
          />
        );

      case "afshan":
        return (
          <AfshanRug
            background={selectedRug.background}
            border={selectedRug.border}
            show={true}
          />
        );

      case "modern":
        return (
          <ModernRug
            background={selectedRug.background}
            pattern={selectedRug.pattern}
            show={true}
          />
        );

      default:
        return (
          <LachakToranjRug
            background={selectedRug.background}
            border={selectedRug.border}
            corner={selectedRug.corner}
            toranj={selectedRug.toranj}
            show={true}
          />
        );

        break;
    }
  };

  const rugClickHandler = (rug, index, type = "selected") => {
    if (
      (activeTabs !== "your_rug" && type == "similar") ||
      activeTabs == "your_rug"
    ) {
      setSelectedRug(rug);
    }
    if (rug.id && rug.id > 0) {
      if (sellersRugId !== rug.id) {
        setSellersRugId(rug.id);
        setSellersLoading(true);
        loadSellers(rug.id);
      }
    } else {
      setSelectedRugIndex(index);
      handleSelectedSimilarRugs(selectedRugIndex);
    }
  };

  const ghalichin_shop = {
    type: "ghalichin",
    seller: {
      map_url:
        "https://www.google.com/maps/place/%D9%82%D8%A7%D9%84%DB%8C%DA%86%DB%8C%D9%86+%7C%D9%87%D8%A7%DB%8C%D9%BE%D8%B1%D9%85%D8%A7%D8%B1%DA%A9%D8%AA+%D9%85%D8%AC%D8%A7%D8%B2%DB%8C+%D9%81%D8%B1%D8%B4+%D9%85%D8%A7%D8%B4%DB%8C%D9%86%DB%8C+%D9%88+%D8%AF%D8%B3%D8%AA%D8%A8%D8%A7%D9%81+%7C+Rug+%26+Carpet%E2%80%AD/@35.7180049,51.4059239,18.48z/data=!4m5!3m4!1s0x3f8e016b0512c73d:0xe0f24edb83529040!8m2!3d35.7176293!4d51.4077656",
      name: "فروشگاه قالیچین",
      phone: "021-88906680",
      address:
        "میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش - پلاک ۴ - رویای کمال",
      logo: "/static/img/ghalichin logo3.png",
      link: {
        pathname: `/generator`,
        search: "?page=your_pic",
        state: {
          image: selectedRug,
        },
      },
    },
  };

  const loadSellers = (rugID) => {
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getRugSellers(rugID, sellersOrder, selectedCities)
      .then((response) => {
        if (response.success) {
          setSellers(response.data.results);
        }
        setSellersLoading(false);
      });
  };

  const changeRoute = (tab) =>
    props.context.history.push(`/generator?page=${tab}`);

  const orderHandler = (order) => {
    if (order !== sellersOrder && selectedRug.id) {
      setSellersOrder(order);
      loadSellers(sellersRugId);
      setIsOpenSortList(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Header />
      <div
        style={{
          zIndex: 1000,
          position: "absolute",
          top: 155,
          width: "100%",
          padding: "0 11px",
        }}
      >
        <RugTabs
          activeTabs={activeTabs}
          selectTabs={changeRoute}
          texts={props.texts}
        />
      </div>
      <div style={{ padding: "0 11px" }}>
        <div
          className=" shadow-div"
          style={{
            padding: isMobile ? "20px 11px" : "30px 27px",
            position: "relative",
            marginTop: isMobile ? 60 : 90,
          }}
        >
          <div className="d-flex flex-wrap">
            <div
              style={{
                width: isMobile ? "100%" : "45%",
                padding: isMobile ? "12px" : "12px 23px 23px",
                border: "1px solid #dfdede",
                borderRadius: 10,
                fontSize: 12,
                color: "#5e6777",
              }}
            >
              <p className="text-center"> {props.texts["selectedRugs"]}</p>
              <div className="test-3D test-3D-light">
                <div className="text-center selected-mobile-display">
                  {isMobile ? (
                    <div className="d-flex" style={{ height: 150 }}>
                      <button
                        style={{ backgroundColor: "#fff", width: 20 }}
                        onClick={() => {
                          if (
                            scrollRef.current.scrollWidth >
                            scrollRef.current.clientWidth
                          )
                            scrollRef.current.scrollTo({
                              left: scrollRef.current.scroll - 100,
                              behavior: "smooth",
                            });
                        }}
                      >
                        <ChevronRightRoundedIcon
                          style={{ color: "#de2a35", fontSize: 30 }}
                        />
                      </button>

                      <div
                        ref={scrollRef}
                        style={{ overflowX: "scroll", overflowY: "hidden" }}
                        className="relative ul-body  pt-4 my-4"
                      >
                        {rugs?.map((rug, index) =>
                          handleSelectedRugs(rug, index, "selected")
                        )}
                      </div>
                      <button
                        style={{ backgroundColor: "#fff", width: 20 }}
                        onClick={() => {
                          if (
                            scrollRef.current.scrollWidth >
                            scrollRef.current.clientWidth
                          )
                            scrollRef.current.scrollTo({
                              left: scrollRef.current.scrollLeft - 100,
                              behavior: "smooth",
                            });
                        }}
                      >
                        <KeyboardArrowLeftRoundedIcon
                          style={{ color: "#de2a35", fontSize: 30 }}
                        />
                      </button>
                    </div>
                  ) : (
                    <div
                      className="relative ul-body  mt-4 "
                      style={{ overflowX: "scroll" }}
                    >
                      {rugs?.map((rug, index) =>
                        handleSelectedRugs(rug, index, "selected")
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "45%",
                marginRight: isMobile ? 0 : 28,
                padding: isMobile ? "12px" : "12px 23px 23px",
                backgroundColor: "#fafafa",
                borderRadius: 10,
                fontSize: 12,
                color: "#5e6777",
                marginTop: isMobile ? 28 : 0,
              }}
            >
              <p className="text-center">{props.texts["similarRugs"]} </p>
              <div className="test-3D test-3D-light">
                <div className="text-center selected-mobile-display">
                  {isMobile ? (
                    <div className="d-flex" style={{ height: 150 }}>
                      <button
                        style={{ background: "transparent", width: 20 }}
                        onClick={() => {
                          if (
                            similarScrollRef.current.scrollWidth >
                            similarScrollRef.current.clientWidth
                          )
                            similarScrollRef.current.scrollTo({
                              left: similarScrollRef.current.scroll - 100,
                              behavior: "smooth",
                            });
                        }}
                      >
                        <ChevronRightRoundedIcon
                          style={{ color: "#de2a35", fontSize: 30 }}
                        />
                      </button>

                      <div
                        ref={similarScrollRef}
                        className="ul-body m-0 align-items-center"
                        style={{ overflowX: "scroll", overflowY: "hidden" }}
                      >
                        {activeSimilarRugs?.map((rug, index) =>
                          handleSelectedRugs(rug, index, "similar")
                        )}
                      </div>
                      <button
                        style={{ background: "transparent", width: 20 }}
                        onClick={() => {
                          if (
                            similarScrollRef.current.scrollWidth >
                            similarScrollRef.current.clientWidth
                          )
                            similarScrollRef.current.scrollTo({
                              left: similarScrollRef.current.scrollLeft - 100,
                              behavior: "smooth",
                            });
                        }}
                      >
                        <KeyboardArrowLeftRoundedIcon
                          style={{ color: "#de2a35", fontSize: 30 }}
                        />
                      </button>
                    </div>
                  ) : (
                    <div
                      className="relative ul-body  mt-4 "
                      style={{ overflowX: "scroll" }}
                    >
                      {activeSimilarRugs?.map((rug, index) =>
                        handleSelectedRugs(rug, index, "similar")
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!isMobile && (
            <div className="d-flex justify-content-between mt-4">
              <button
                className="d-flex align-items-center"
                style={{
                  color: "#de2a35",
                  margin: 0,
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                onClick={() => props.context.history.goBack()}
              >
                {themeDirection == "ltr" ? (
                  <KeyboardArrowLeftRoundedIcon />
                ) : (
                  <ChevronRightRoundedIcon />
                )}

                <span className="mr-2">{texts.back_market}</span>
              </button>
              <button
                className="d-flex align-items-center justify-content-between"
                style={{
                  backgroundColor: "#de2a35",
                  color: "#fff",
                  margin: 0,
                  borderRadius: 25,
                  height: 45,
                  padding: "0 20px",
                  width: 154,
                }}
              >
                <span className="m-0">{texts.carpet_show}</span>
                {themeDirection == "ltr" ? (
                  <ChevronRightRoundedIcon />
                ) : (
                  <KeyboardArrowLeftRoundedIcon />
                )}
              </button>
            </div>
          )}

          <div
            className="mt-4 d-flex justify-content-center"
            style={{ position: "relative" }}
          >
            <img
              src={backgroundImages[selectedBackground]}
              className="w-100"
              style={{
                height: isMobile ? 291 : 531,
                objectFit: "cover",
                borderRadius: 10,
              }}
            />
            <div
              className="d-flex justify-content-between"
              style={{
                position: "absolute",
                left: isMobile ? -18 : -25,
                right: isMobile ? -18 : -25,
                top: "45%",
              }}
            >
              <button
                style={{
                  color: isMobile ? "#fff" : "#de2a35",
                  backgroundColor: isMobile ? "#de2a35" : "#fff",
                  margin: 0,
                  borderRadius: 25,
                  height: 45,
                  padding: isMobile ? 0 : "0 10px",
                  border: "1px solid #de2a35",
                  minWidth: isMobile ? 45 : 90,
                  fontSize: 20,
                }}
                className="d-flex align-items-center  justify-content-between"
                onClick={() =>
                  selectedBackground == 0
                    ? setSelectedBackground(3)
                    : setSelectedBackground(selectedBackground - 1)
                }
              >
                {themeDirection == "ltr" ? (
                  <KeyboardArrowLeftRoundedIcon
                    style={{ width: 32, height: 32 }}
                  />
                ) : (
                  <ChevronRightRoundedIcon style={{ width: 32, height: 32 }} />
                )}
                {!isMobile ? <span>{texts.next}</span> : ""}
              </button>
              <button
                style={{
                  color: isMobile ? "#fff" : "#de2a35",
                  backgroundColor: isMobile ? "#de2a35" : "#fff",
                  margin: 0,
                  borderRadius: 25,
                  height: 45,
                  padding: isMobile ? 0 : "0 10px",
                  border: "1px solid #de2a35",
                  minWidth: isMobile ? 45 : 90,
                  fontSize: 20,
                }}
                onClick={() =>
                  selectedBackground == 3
                    ? setSelectedBackground(0)
                    : setSelectedBackground(selectedBackground + 1)
                }
                className="d-flex align-items-center  justify-content-between"
              >
                {!isMobile ? <span>{texts.previous}</span> : ""}

                {themeDirection == "ltr" ? (
                  <ChevronRightRoundedIcon style={{ width: 32, height: 32 }} />
                ) : (
                  <KeyboardArrowLeftRoundedIcon
                    style={{ width: 32, height: 32 }}
                  />
                )}
              </button>
            </div>

            <div
              style={{
                transition: "all 4s ease",
                //width: isMobile ? 210 : 390,
                // height: isMobile ? "auto" : 175,
                position: "absolute",
                bottom: isMobile ? (show3D ? -62 : 20) : show3D ? -130 : 0,
              }}
            >
              <Draggable
                nodeRef={draggRef}
                bounds={{
                  top: -100,
                  left: isMobile ? -100 : -200,
                  right: isMobile ? 100 : 200,
                  bottom: 0,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: isMobile && show3D ? 175 : "auto",
                    position: "relative",
                    display: "flex",
                  }}
                >
                  <div
                    className={
                      show3D
                        ? "carpet-3D preview-rotation-reverse"
                        : "carpet-3D preview-rotation"
                    }
                    // ref={draggRef}
                    onClick={() => {
                      show3D ? setShow3D(show3D) : setShow3D(!show3D);
                    }}
                    onTouchStart={() => {
                      show3D ? setShow3D(show3D) : setShow3D(!show3D);
                    }}
                  >
                    <div className="rotation-mobile-time">
                      <div
                        className="text-center before-body-carpet relative"
                        ref={imageRef}
                      >
                        <div className="body-carpet" id="report">
                          {selectedRug && selectedRug?.full_image ? (
                            <div className="previwe">
                              <div
                                onDragStart={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                <ImageRugs image={selectedRug.full_image} />
                              </div>
                            </div>
                          ) : (
                            <div className="previwe">
                              {showSelectedRug(selectedRug)}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Draggable>
            </div>
          </div>
        </div>
      </div>

      {/* seller this should be one component */}
      <div
        className={!isMobile && " shadow-div"}
        style={{
          padding: "30px 0px",
          position: "relative",
          minHeight: 300,
          marginTop: 19,
        }}
      >
        <div
          className="d-flex justify-content-between"
          style={{
            border: "1px solid #e7eaef",
            borderRadius: 10,
            padding: 18,
            color: "#de2a35",
            margin: isMobile ? "0px 11px" : "0px 27px",
          }}
          onClick={() => setIsOpenSortList(!isOpenSortList)}
        >
          <span
            style={{
              flex: 1,
              fontSize: isMobile ? 12 : 18,
              fontWeight: "bold",
            }}
          >
            {props.texts.storesForThisRug}
          </span>
          <span
            className="d-flex align-items-center"
            style={{ fontSize: 14, textAlign: "left" }}
          >
            <span style={{ flex: 1 }}>{texts.ordering}</span>
            <KeyboardArrowDownRoundedIcon />
          </span>
        </div>
        {isOpenSortList && (
          <div
            style={{
              position: "absolute",
              background: "#fff",
              left: 27,
              right: 27,
              textAlign: "left",
              borderRadius: 10,
              padding: 18,
              top: 100,
              border: "1px solid #e7eaef",
              color: "#de2a35",
              zIndex: 100,
            }}
          >
            <ul style={{ cursor: "pointer" }}>
              <li className="my-2" onClick={() => orderHandler("")}>
                {props.texts.latest}
              </li>
              <li className="my-2" onClick={() => orderHandler("oldest")}>
                {props.texts.oldest}
              </li>
              <li className="my-2" onClick={() => orderHandler("on_sale")}>
                {" "}
                {props.texts.onSale}
              </li>
            </ul>
          </div>
        )}

        <div className=" cards-body">
          {sellersLoading && selectedRug.id && (
            <div className="row mt-5 mb-5">
              <p className="empty mt-5">
                {props.texts["searchingForSellers"]}{" "}
              </p>
            </div>
          )}

          {!selectedRug.id &&
            (Object.keys(selectedRug)?.length ? (
              <div className="mt-5">
                <StoreCard seller={ghalichin_shop} texts={props.texts} />
              </div>
            ) : (
              <div className="row mt-5 mb-5">
                <p className="empty mt-5">
                  {props.texts["selectOneSimilarRug"]}
                </p>
              </div>
            ))}
          {sellers.length > 0 && selectedRug.id && (
            <div
              className="d-flex justify-content-start mt-5"
              style={{
                position: "relative",
                margin: "0 13.5px",
                overflowX: "scroll",
                flexWrap: "initial",
              }}
            >
              {sellers?.map((seller) => (
                <StoreCard seller={seller} texts={props.texts} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewRugPreview;
